import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import logo from '../../res/img/kredit-logo.png';

const Error: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section style={{ background: 'white' }} className="w-full inset-0 flex items-center justify-center fixed z-50">
            <div className="max-w-sm md:max-w-lg w-full">
                <div className="text-center mb-5 md:mb-8">
                    <Link
                        to="/"
                        replace={true}
                        className="text-4xl font-extrabold text-blue-1 text-center inline-block"
                    >
                        <img className="h-8" src={logo} alt="logo" data-testid="logo" />
                    </Link>
                </div>
                <p className="text-lg text-center text-dark-3 italic mb-5 md:mb-8">{t('errorPage.error')}</p>
                <h1 className="text-4xl md:text-5xl font-semibold italic text-dark-3 text-center mb-5 md:mb-8">
                    {t('errorPage.body')}
                </h1>
                <Link
                    to="/"
                    replace={true}
                    className="block w-full text-center text-sm text-white py-2.5 px-6 rounded-lg bg-blue"
                >
                    {t('BUTTONS.BACK')}
                </Link>
            </div>
        </section>
    );
};

export default Error;
